import VisualCheckboxCloud from './VisualCheckboxCloud';
export * from './VisualCheckboxCloud';
export default VisualCheckboxCloud;
